import {Injectable} from "@angular/core";
import * as SecureLS from "secure-ls";

@Injectable({providedIn: 'root'})
export class LocalstorageService {

  registerUserKey = '[KWOT]-registerUser';
  cartKey = '[KWOT]-cart';
  redirectUrlKey = '[KWOT]-redirectUrl';
  userKey = '[KWOT]-kwotUser';
  countryCodeKey = '[KWOT]-countryCode';
  registerNumberKey = '[KWOT]-registerNumber';
  commonKey = '[KWOT]-commonKey';
  deviceId = '[KWOT]-deviceId';
  recentlyViewProduct = '[KWOT]-recentlyView';
  latestWishList = '[KWOT]-latest wishList';
  geolocationData = '[KWOT]-geolocationData';
  recentlySearch = '[KWOT]-recent search'
  guestUserKey = '[KWOT]-guestUser'
  chatUserKey = '[KWOT]-chatUser'
  stripePayment = '[KWOT]-stripePayment'
  isB2B = '[KWOT]-isB2B'
  cartDetails = '[KWOT]-cart-details'
  measurements = '[KWOT]-measurements'
  stripeSubscription = '[KWOT]-stripeSubscription'
  selectedCurrency = '[KWOT]-selected-currency'
  selectedRfqProduct = '[KWOT]-selected-rfqProduct'
  selectedCopyRfq = '[KWOT]-selected-copyRfq'
  selectedContactRfq = '[KWOT]-selected-contactRfq'
  selectedVendorCartItem = '[KWOT]-selected-vendor-cart-item'
  ls = new SecureLS({encodingType: 'aes'});

  constructor() {
  }

  clearAllLocalStorage() {
    this.updateRegisterUser('remove');
    this.updateRedirectUrl('remove');
    this.updateCountryCode('remove');
    this.updateRegisterNumber('remove');
    this.updateUserKey('remove');
    // this.updateCart('remove');
    this.updateCommonKey('remove');
    this.updateGeolocation('remove');
    this.updateRecentSearch('remove');
    this.updateGuestUserKey('remove');
    this.updateStripePayment('remove');
    this.updateWishlist('remove');
    this.updateIsB2B('remove');
    // this.updateCartDetails('remove');
    this.updateMeasurementDetails('remove');
    this.updateStripeSubscription('remove');
    this.updateChatUserKey('remove');
    this.updateSelectedProduct('remove');
    this.updateSelectedCopyRfq('remove');
    this.updateSelectedContactRfq('remove');
    this.updateSelectedVendorCartItem('remove');
  }

  updateRegisterUser(type: string, data: any = null) {
    return this.updateLocalStorage(this.registerUserKey, type, data, true)
  }

  // updateCartDetails(type: string, data: any = null) {
  //   return this.updateLocalStorage(this.cartDetails, type, data, true)
  // }

  // updateCart(type: string, data: any = null) {
  //   return this.updateLocalStorage(this.cartKey, type, data, true)
  // }

  updateWishlist(type: string, data: any = null) {
    return this.updateLocalStorage(this.latestWishList, type, data, true)
  }

  updateRedirectUrl(type: string, data: any = null) {
    return this.updateLocalStorage(this.redirectUrlKey, type, data)
  }

  updateCountryCode(type: string, data: any = null) {
    return this.updateLocalStorage(this.countryCodeKey, type, data)
  }

  updateRegisterNumber(type: string, data: any = null) {
    return this.updateLocalStorage(this.registerNumberKey, type, data)
  }

  updateUserKey(type: string, data: any = null) {
    return this.updateLocalStorage(this.userKey, type, data, true)
  }

  updateCommonKey(type: string, data: any = null) {
    return this.updateLocalStorage(this.commonKey, type, data, true)
  }

  updateDeviceId(type: string, data: any = null) {
    return this.updateLocalStorage(this.deviceId, type, data, true)
  }

  updateRecentlyViewProduct(type: string, data: any = null) {
    return this.updateLocalStorage(this.recentlyViewProduct, type, data, true)
  }

  updateGeolocation(type: string, data: any = null) {
    return this.updateLocalStorage(this.geolocationData, type, data, true)
  }

  updateRecentSearch(type: string, data: any = null) {
    return this.updateLocalStorage(this.recentlySearch, type, data, true)
  }

  updateGuestUserKey(type: string, data: any = null) {
    return this.updateLocalStorage(this.guestUserKey, type, data, true)
  }

  updateChatUserKey(type: string, data: any = null) {
    return this.updateLocalStorage(this.chatUserKey, type, data, true)
  }

  updateStripePayment(type: string, data: any = null) {
    return this.updateLocalStorage(this.stripePayment, type, data, true)
  }

  updateIsB2B(type: string, data: any = null) {
    return this.updateLocalStorage(this.isB2B, type, data)
  }

  updateMeasurementDetails(type: string, data: any = null) {
    return this.updateLocalStorage(this.measurements, type, data, true);
  }

  updateStripeSubscription(type: string, data: any = null) {
    return this.updateLocalStorage(this.stripeSubscription, type, data);
  }

  private updateLocalStorage(key: string, type: string, data: any = null, isJson = false) {
    if (type === 'store') {
      return this.ls.set(key, isJson ? JSON.stringify(data) : data);
    } else if (type === 'remove') {
      return this.ls.remove(key)
    } else if (type === 'get') {
      const data = this.ls.get(key);
      return isJson ? (data ? JSON.parse(data) : null) : (data || '');
    }
    return null;
  }

  updateSelectedCurrency(type: string, data: any = null) {
    return this.updateLocalStorage(this.selectedCurrency, type, data,true);
  }

  updateSelectedProduct(type: string, data: any = null) {
    return this.updateLocalStorage(this.selectedRfqProduct, type, data,true);
  }

  updateSelectedCopyRfq(type: string, data: any = null) {
    return this.updateLocalStorage(this.selectedCopyRfq, type, data,true);
  }

  updateSelectedContactRfq(type: string, data: any = null) {
    return this.updateLocalStorage(this.selectedContactRfq, type, data,true);
  }

  updateSelectedVendorCartItem(type: string, data: any = null) {
    return this.updateLocalStorage(this.selectedVendorCartItem, type, data,true);
  }
}
